import { render, staticRenderFns } from "./BlurbCard.vue?vue&type=template&id=0c6faf83&"
import script from "./BlurbCard.vue?vue&type=script&lang=js&"
export * from "./BlurbCard.vue?vue&type=script&lang=js&"
import style0 from "./BlurbCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BlurbCard.vue"
export default component.exports